import { render, staticRenderFns } from "./attachment-bulk-actions.vue?vue&type=template&id=2e8b0883"
import script from "./attachment-bulk-actions.vue?vue&type=script&lang=js"
export * from "./attachment-bulk-actions.vue?vue&type=script&lang=js"
import style0 from "./attachment-bulk-actions.vue?vue&type=style&index=0&id=2e8b0883&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports